import { Label, Text } from "react-aria-components";
import { StyledRadio, StyledRadioGroup, StyledIndicator, StyledRadioIcon } from "./radio.style";
import { MDSRadioProps, MDSRadioGroupProps, MDSRadioSlotName } from "./radio.types";
import { getSlot } from "@/mds/utils/slots";
import { MdsIconKind } from "@/design-system/components/icon";

export const MDSRadio = ({ children, value, ...props }: MDSRadioProps) => {
  return (
    <StyledRadio {...props} value={value}>
      {({ isSelected }) => (
        <>
          <StyledIndicator>
            <StyledRadioIcon
              kind={isSelected ? MdsIconKind.CheckCircleSolid : MdsIconKind.Circle}
              isSelected={isSelected}
            />
          </StyledIndicator>
          <Label>{children}</Label>
        </>
      )}
    </StyledRadio>
  );
};

export const MDSRadioGroup = ({
  children,
  label,
  description,
  errorMessage,
  ...props
}: MDSRadioGroupProps) => {
  return (
    <StyledRadioGroup {...props}>
      {label && <Label>{label}</Label>}
      {description && <Text slot="description">{description}</Text>}
      {getSlot(children, MDSRadioSlotName.Before)}
      {children}
      {getSlot(children, MDSRadioSlotName.After)}
      {errorMessage && <Text slot="errorMessage">{errorMessage}</Text>}
    </StyledRadioGroup>
  );
};
